import { render, staticRenderFns } from "./Signup.demo.vue?vue&type=template&id=3ac1cb29&"
import script from "./Signup.demo.vue?vue&type=script&lang=js&"
export * from "./Signup.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports